<!--收入分析-->
<template>
  <div  class="app-container">
    <!--    查询条件区域-->
    <div class="title-container" shadow="never">
      <div class="title-con">
        <i class="el-icon-search"></i>
        <span style="margin-left: 5px;">筛选搜索</span>
      </div>
    </div>
    <el-card class="operate-container" shadow="never" style="margin-top: 0px;">
      <div class="filter-container" style="margin-top: 10px">
        <el-form :inline="true" :model="queryParam" label-width="80px">
          <el-form-item label="选择月份:">
            <el-date-picker
              v-model="queryParam.month"
              type="month"
              value-format="yyyy-MM-dd"
              placeholder="选择月">
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div class="button-container" style="margin-top: 0px">
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search" @click="onBtnSearch()">查 询</el-button>
      </div>
    </el-card>
    <div class="title-container" shadow="never" style="margin-top: 20px;">
      <div class="title-con">
        <i class="el-icon-tickets"></i>
        <span style="margin-left: 5px;">数据列表</span>
      </div>
      <div></div>
    </div>
    <div class="table-container" style="margin-top: 0px;">
      <el-table ref="tableData"
                :data="tableData"
                v-loading="listLoading" border
                highlight-current-row
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}">
        <el-table-column prop="month" label="月份"></el-table-column>
        <el-table-column prop="saleTotalMoney" label="销售金额"></el-table-column>
        <el-table-column prop="saleTotalCardNum" label="销售卡数量" ></el-table-column>
        <el-table-column prop="saleUnitPrice" label="销售客单价" ></el-table-column>
        <el-table-column prop="consumeTotalMoney" label="耗卡总金额" ></el-table-column>
        <el-table-column prop="consumeCardNum" label="耗卡数量" ></el-table-column>
        <el-table-column prop="consumeUnitPrice" label="耗卡客单价" ></el-table-column>
      </el-table>
    </div>
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="queryParam.pageNum"
        :page-size="queryParam.pageSize"
        :page-sizes="queryParam.pageSizes"
        :total="queryParam.totalPage">
      </el-pagination>
    </div>
  </div>
</template>
<style scoped>
  /deep/ .el-table th.el-table__cell>.cell{
    width: 90%;
    height: auto;
    background: #ecf3fd;
    border-radius: 8px;
  }
  /deep/ .el-table__header-wrapper .cell{
    line-height: 45px;
    color: #0d6fb8;
  }
  /deep/ .el-dialog--center{
    border: 2px solid #d0d0d0;
    border-radius: 10px;
  }
  /deep/ .el-dialog__header{
    border-radius: 10px;
    background: #f0f7ff;
  }

</style>
<script>
  import globaldata from "../../../utils/globaldata";

  import commonUtils from "../../../utils/commonUtils";
  import {queryIncomeAnalysis, queryMonthOnMonthData} from "../../../api/bas/busnessAnalysis";
  import timeUtils from "../../../utils/timeUtils";
  import {formatDate} from "../../../utils/date";
  import enumsUtil from "../../../utils/enumsUtil";


  export default {
    data() {
      return {
        tableData:[],
        listLoading: true,
        queryParam :{
          storeFrontId: globaldata.getAdminStore().storeFrontId,
          month:"",
          //分页查询
          pageNum :1 ,//当前第几页
          totalPage :1, //总共页数
          pageSize : 10,
          pageSizes:[10,20,50,100],
        },
      }
    },
    created() {
      this.queryParam.month = formatDate(new Date(),"yyyy-MM-dd");
      this.fitchData();
    },
    methods: {
      handleSizeChange(val) {
        this.queryParam.pageNum = 1;
        this.queryParam.pageSize = val;
        this.fitchData();
      },
      handleCurrentChange(val) {
        this.queryParam.pageNum = val;
        this.fitchData();
      },
      //点击查询按钮
      onBtnSearch(){
        this.fitchData();
      },
      fitchData(){
        this.listLoading = true;
        let param = {
          storeFrontId: globaldata.getAdminStore().storeFrontId,
          lessonTemplateId:enumsUtil.lessonTemplateIdCF(),
          month:this.queryParam.month

        }
        const loading = this.myLoading();
        queryMonthOnMonthData(param).then(response => {
          this.listLoading = false;
          loading.close();
          let data = response.data;
          if (commonUtils.isObjectNull(data)){
            return;
          }
          this.refreshData(data);
        })
      },
      //刷新页面数据
      refreshData(list){

        if (commonUtils.isObjectNull(list)){
          return;
        }
        this.tableData = list;

      },


    }
  }
</script>






// WEBPACK FOOTER //
// src/views/market-analysis/ma-month-on-month/index.vue